webpackJsonp([9],{

/***/ 1898:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(1917),
  /* template */
  __webpack_require__(1976),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 1910:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_services_http__ = __webpack_require__(7);




/* harmony default export */ __webpack_exports__["a"] = ({
  find: function find(lote) {
    return __WEBPACK_IMPORTED_MODULE_2__utils_services_http__["a" /* default */].get('/api/lote/' + lote + '/dados-consulta').then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (_ref) {
      var response = _ref.response;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(response);
    });
  },
  update: function update(dadosId, data) {
    return __WEBPACK_IMPORTED_MODULE_2__utils_services_http__["a" /* default */].patch('/api/lote/dados-consulta/' + dadosId, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data)).then(function (response) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(response);
    }).catch(function (_ref2) {
      var response = _ref2.response;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(response);
    });
  }
});

/***/ }),

/***/ 1917:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_services_lote_dados_consulta__ = __webpack_require__(1910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  nome: 'dados-consulta-lote-detro',
  data: function data() {
    return {
      isLoading: false,
      isLoaded: true,
      cadastroError: null,
      atualizadoSucesso: null,
      data: {
        id: null,
        consultadoNoDetran: false,
        periciaComunicadaNoDetran: false,
        extratoComunicadoDetran: false,
        conteudoExtratoDetran: null,
        respostas: [],
        lote: this.$route.params.id
      },
      respostasFormatadas: null
    };
  },

  computed: {},
  mounted: function mounted() {
    this.start();
  },

  methods: {
    start: function start() {
      var _this = this;

      if (this.$route.params.id) {
        this.$parent.loading(true);
        __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_services_lote_dados_consulta__["a" /* default */].find(this.$route.params.id).then(function (response) {
          _this.isLoaded = true;
          _this.data = response.data;
          _this.data.lote = _this.data.lote.id;
          _this.respostasFormatadas = '[' + _this.data.respostas.join(',') + ']';
          console.log(_this.respostasFormatadas);
          _this.respostasFormatadas = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(JSON.parse(_this.respostasFormatadas), undefined, 4);
        }).catch(function (response) {
          console.log(response);
        }).finally(function () {
          _this.$parent.loading(false);
        });
      } else {
        this.isLoaded = true;
      }
    },
    submit: function submit() {
      var _this2 = this;

      this.cadastroError = null;
      this.atualizadoSucesso = false;
      this.$bar.start();
      this.$parent.loading(true);
      __WEBPACK_IMPORTED_MODULE_1__domain_leiloes_services_lote_dados_consulta__["a" /* default */].update(this.data.id, this.data).then(function (response) {
        var callbackEnd = function callbackEnd() {
          _this2.$emit('finishSubmit');
        };
        callbackEnd();
      }).catch(function (response) {
        _this2.cadastroError = response.data.errors;
        _this2.$nextTick(function () {
          _this2.$refs.error.focus();
        });
        console.log(response);
      }).finally(function () {
        _this2.$bar.finish();
        _this2.$parent.loading(false);
      });
    },
    printError: function printError(err) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash__["isArray"])(err)) {
        return err[0];
      }
      return err;
    },
    openAnotherWindow: function openAnotherWindow() {
      var json = this.syntaxHighlight(this.respostasFormatadas);
      var w = window.open();
      var html = '<!DOCTYPE html><head><title>003/005/007</title> <style>pre {outline: 1px solid #ccc; padding: 5px; margin: 5px; color: purple; } .string { color: #05b205; }\n     .number { color: blue; } .boolean { color: darkblue; } .null { color: magenta; } .key { color: black; } h1{font-family: sans-serif; color: #7266ba}</style></head>\n     <body><h1>Dados das consultas 003 / 005 / 007</h1><pre>' + json + '</pre></body></html>';
      w.document.writeln(html);
    },
    syntaxHighlight: function syntaxHighlight(json) {
      json = json.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
      return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
        var cls = 'number';
        if (/^"/.test(match)) {
          if (/:$/.test(match)) {
            cls = 'key';
          } else {
            cls = 'string';
          }
        } else if (/true|false/.test(match)) {
          cls = 'boolean';
        } else if (/null/.test(match)) {
          cls = 'null';
        }
        return '<span class="' + cls + '">' + match + '</span>';
      });
    }
  }
});

/***/ }),

/***/ 1976:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Dados da consulta")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar, corrija e tente novamente")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v(_vm._s(_vm.$route.params.id && 'Atualizado' || 'Cadastrado') + " com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('form', {
    staticClass: "bs-example form-horizontal",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Consultado no DETRAN")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.consultadoNoDetran),
      expression: "data.consultadoNoDetran"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.consultadoNoDetran) ? _vm._i(_vm.data.consultadoNoDetran, null) > -1 : (_vm.data.consultadoNoDetran)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.consultadoNoDetran,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "consultadoNoDetran", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "consultadoNoDetran", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "consultadoNoDetran", $$c)
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Retorno da consulta no DETRAN")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.respostasFormatadas),
      expression: "respostasFormatadas"
    }],
    staticClass: "form-control",
    staticStyle: {
      "white-space": "pre-wrap"
    },
    attrs: {
      "rows": "8",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.respostasFormatadas)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.respostasFormatadas = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "flex",
      "justify-content": "flex-end"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.openAnotherWindow
    }
  }, [_vm._v("Expandir em outra aba")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Perícia comunicada no DETRAN")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.periciaComunicadaNoDetran),
      expression: "data.periciaComunicadaNoDetran"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.periciaComunicadaNoDetran) ? _vm._i(_vm.data.periciaComunicadaNoDetran, null) > -1 : (_vm.data.periciaComunicadaNoDetran)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.periciaComunicadaNoDetran,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "periciaComunicadaNoDetran", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "periciaComunicadaNoDetran", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "periciaComunicadaNoDetran", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Extrato comunicado no DETRAN")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.extratoComunicadoDetran),
      expression: "data.extratoComunicadoDetran"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.data.extratoComunicadoDetran) ? _vm._i(_vm.data.extratoComunicadoDetran, null) > -1 : (_vm.data.extratoComunicadoDetran)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.data.extratoComunicadoDetran,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.data, "extratoComunicadoDetran", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.data, "extratoComunicadoDetran", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.data, "extratoComunicadoDetran", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Retorno do extrato")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.data.conteudoExtratoDetran),
      expression: "data.conteudoExtratoDetran"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "8"
    },
    domProps: {
      "value": (_vm.data.conteudoExtratoDetran)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.data, "conteudoExtratoDetran", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn w-xs btn-info m-r-xs",
    on: {
      "click": _vm.submit
    }
  }, [_c('span', [_vm._v("Atualizar")])]), _vm._v(" "), _c('u-button', {
    staticClass: "btn w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancelar")])], 1)])])])])]) : _vm._e()])
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/9.87a3612bdb98f7830fcc.js